import { URLS } from '../../../constants';
import apiClient from '../../client';

const getAllData = {
  getTechnicianAndClinician: () =>
    apiClient.post(URLS.primaryProvider, {
      data: {},
    }),
  getServiceProvider: ({
    isEditAppointment,
    authorizationCodes,
  }: {
    isEditAppointment?: any;
    authorizationCodes?: any;
  }) =>
    apiClient.post(URLS.serviceProvider, {
      data: { isEditAppointment, authorizationCodes },
    }),
  getPlaceAndService: () =>
    apiClient.post(URLS.placeService, {
      data: {},
    }),
  getAuthorizationAndNonBillable: ({
    codeType,
    clientId,
    serviceProviderId,
    startTime,
  }: {
    codeType: string;
    clientId: any;
    serviceProviderId: any;
    startTime: any;
  }) =>
    apiClient.post(URLS.authorizationNonBillable, {
      data: { codeType, clientId, serviceProviderId, startTime },
    }),
  servicePlaces: () =>
    apiClient.post(URLS.getServicePlaces, {
      data: {},
    }),
  getOrgSpecificServicePlaces: () =>
    apiClient.post(URLS.getOrgSpecificServicePlaces, {
      data: {},
    }),
  getAllAdditionalParticipants: () =>
    apiClient.post(URLS.getAllAdditionalParticipants, {
      data: {},
    }),
  getTechnicianAndClinicianActiveInactive: () =>
    apiClient.post(URLS.primaryProviderActiveInactive, {
      data: {},
    }),
};
export default getAllData;
